<ng-container *ngIf="question">
  <div class="q">
    <div class="title" *ngIf="question.cp_question.response_type !== 'CONCAT'">
      <div
        class="question-statement notranslate"
        appNoTranslate
        [innerHTML]="parsedStatement"
      ></div><span *ngIf="question.cp_question.elective === false" class="required-marker">&nbsp;*</span>
    <button
        *ngIf="canSpeak"
      mat-icon-button
      [attr.aria-label]="((isSpeaking$ | async) ? 'StopSpeaking' : 'SpeakQuestion') | translate"
      (click)="toggleSpeak()"
      [matTooltip]="((isSpeaking$ | async) ? 'StopSpeaking' : 'SpeakQuestion') | translate"
      class="speak-btn"
    >
      <mat-icon>{{ (isSpeaking$ | async) ? 'stop' : 'volume_up' }}</mat-icon>
    </button>
    <button
        *ngIf="question.cp_question.configuration?.tooltip"
      mat-icon-button
     aria-label="Show info"
      (click)="showTooltip()"
     [matTooltip]="tooltipText"
     matTooltipClass="custom-tooltip"
     class="tooltip-btn"
    >
      <mat-icon>info</mat-icon>
    </button>
    </div>

    <!-- Ineligibility Warning -->
    <div *ngIf="showIneligibilityWarning" class="ineligibility-warning">
      <mat-icon>warning</mat-icon>
      <span>{{ ineligibilityMessage }}</span>
    </div>
    <span [ngSwitch]="question.cp_question.response_type">
      <p *ngSwitchCase="'YESNO'">
        <app-question-yes-no
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-yes-no>
      </p>
      <p *ngSwitchCase="'TOGGLE'">
        <app-question-toggle
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-toggle>
      </p>
      <p *ngSwitchCase="'COUNTRY'">
        <app-question-country
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-country>
      </p>
      <p *ngSwitchCase="'LINK'">
        <app-question-link
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-link>
      </p>
      <p *ngSwitchCase="'SELECT'">
        <app-question-select
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-select>
      </p>
      <p *ngSwitchCase="'MULTI_SELECT'">
        <app-question-multi-select
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-multi-select>
      </p>
      <p *ngSwitchCase="'SEARCH_LIST'">
        <app-question-search-list
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-search-list>
      </p>
      <p *ngSwitchCase="'CHECKBOX'">
        <app-question-checkbox
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-checkbox>
      </p>
      <p *ngSwitchCase="'PHONE'">
        <app-question-phone
          [question]="question.cp_question"
          [user]="user"
          (changeAnswer)="change($event)"
        ></app-question-phone>
      </p>
      <p *ngSwitchCase="'CPF'">
        <app-question-cpf
          [question]="question.cp_question"
          [user]="user"
          (changeAnswer)="change($event)"
        ></app-question-cpf>
      </p>
      <p *ngSwitchCase="'CPF_LEAK_CHECK'">
        <app-question-cpf-leak-check
          [question]="question.cp_question"
          [user]="user"
          (changeAnswer)="change($event)"
        ></app-question-cpf-leak-check>
      </p>
      <p *ngSwitchCase="'API'">
        <app-question-api
          [question]="question.cp_question"
          [user]="user"
          (changeAnswer)="change($event)"
        ></app-question-api>
      </p>
      <p *ngSwitchCase="'DATE'">
        <app-question-date
          [question]="question.cp_question"
          [user]="user"
          (changeAnswer)="change($event)"
        ></app-question-date>
      </p>
      <p *ngSwitchCase="'DATETIME'">
        <app-question-date-time
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-date-time>
      </p>
      <p *ngSwitchCase="'TIME'">
        <app-question-time
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-time>
      </p>
      <p *ngSwitchCase="'MONTHYEAR'">
        <app-question-month-year
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-month-year>
      </p>
      <p *ngSwitchCase="'EXPLANATION'">
        <app-question-explanation
          [question]="question.cp_question"
        ></app-question-explanation>
      </p>
      <p *ngSwitchCase="'NUMBER'">
        <app-question-number
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-number>
      </p>
      <p *ngSwitchCase="'EMAIL'">
        <app-question-email
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-email>
      </p>
      <p *ngSwitchCase="'CURRENCY'">
        <app-question-currency
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-currency>
      </p>
      <p *ngSwitchCase="'WORLD_ADDRESS'">
        <app-question-world-address
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-world-address>
      </p>
      <p *ngSwitchCase="'UK_ADDRESS'">
        <app-question-uk-address
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-uk-address>
      </p>
      <p *ngSwitchCase="'TABLE'">
        <app-question-table
          [context]="context"
          [question]="question.cp_question"
          [user]="user"
          (changeAnswer)="change($event)"
        ></app-question-table>
      </p>
      <p *ngSwitchCase="'MULTI_FILE'">
        <app-question-multi-file
          [context]="context"
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-multi-file>
      </p>
      <p *ngSwitchCase="'CONCAT'">
        <app-question-concat
          [questionnaireAnswer]="qa$"
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-concat>
      </p>
      <p *ngSwitchCase="'MULTI_STEPPER'">
        <app-question-multi-stepper
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-multi-stepper>
      </p>
      <p *ngSwitchCase="'SIGNATURE'">
        <app-question-signature
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-signature>
      </p>
      <p *ngSwitchCase="'CAMERA'">
        <app-question-camera
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-camera>
      </p>
      <p *ngSwitchCase="'CAMERA_FILE'">
        <app-question-camera-file
          [context]="context"
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-camera-file>
      </p>
      <p *ngSwitchCase="'MULTI_CAMERA_FILE'">
        <app-question-multi-camera-file
          [context]="context"
          [question]="question.cp_question"
          (changeAnswer)="change($event)"
        ></app-question-multi-camera-file>
      </p>

      <!-- SHORT_TEXT AND LONG_TEXT WILL BE HERE AND HANDLED BY THE QUESTION_TEXT COMPONENT -->
      <p *ngSwitchDefault="">
        <app-question-text
          [question]="question.cp_question"
          [user]="user"
          (changeAnswer)="change($event)"
        ></app-question-text>
      </p>
    </span>
  </div>
</ng-container>

<ng-container *ngIf="!question">Question not loaded.</ng-container>
